import { FC } from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import ButtonBase from "@mui/material/ButtonBase";
import { Subscriber } from "../../Interfaces/subscriber";

interface Props {
  familyMembers: Subscriber[];
  activeUserId: string;
  onSelectMember: (id: string) => void;
}

const FamilyProfileTabs: FC<Props> = ({
  familyMembers,
  activeUserId,
  onSelectMember,
}) => {
  if (familyMembers.length <= 1) return null;

  return (
    <Box
      sx={{
        position: "sticky",
        top: 0,
        zIndex: 1100,
        background: "linear-gradient(135deg, #000094 0%, #1a1aaf 100%)",
        display: "flex",
        alignItems: "center",
        gap: 1,
        px: 2,
        py: 1.5,
        overflowX: "auto",
        whiteSpace: "nowrap",
        boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.25)",
        "&::-webkit-scrollbar": { display: "none" },
        scrollbarWidth: "none",
      }}
    >
      {familyMembers.map((member) => {
        const isActive = member.id === activeUserId;
        return (
          <ButtonBase
            key={member.id}
            onClick={() => onSelectMember(member.id)}
            sx={{
              fontFamily: "'Source Sans Pro', sans-serif",
              textTransform: "none",
              borderRadius: "8px",
              px: 2.5,
              py: 1,
              minWidth: "auto",
              transition: "all 0.2s ease",
              color: isActive ? "#000094" : "rgba(255,255,255,0.85)",
              bgcolor: isActive ? "#fff" : "rgba(255,255,255,0.08)",
              border: isActive
                ? "none"
                : "1px solid rgba(255,255,255,0.2)",
              boxShadow: isActive
                ? "0px 2px 6px rgba(0, 0, 0, 0.2)"
                : "none",
              "&:hover": {
                bgcolor: isActive ? "#fff" : "rgba(255,255,255,0.18)",
              },
            }}
          >
            <Typography
              sx={{
                fontFamily: "'Source Sans Pro', sans-serif",
                fontWeight: isActive ? 700 : 500,
                fontSize: "14px",
                lineHeight: "20px",
              }}
            >
              {member.firstName} {member.lastName}
            </Typography>
          </ButtonBase>
        );
      })}
    </Box>
  );
};

export default FamilyProfileTabs;
